import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { useMemo } from 'react';

import useTranslation from '../../hooks/useTranslation';
import Select from '../SelectField/SelectField';

const RESIDENT_PERMIT_IDS = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'P',
    'PERMANENT',
    'PROOF_OF_RIGHT_TO_PERMANENT',
    'PROOF_OF_RIGHT_TO_REGISTER',
    'R',
    'TEMPORARY',
    'Z',
];

type Props = {
    name: string;
    label: string;
};

const ResidentPermitField = ({ name, label }: Props) => {
    const translate = useTranslation();

    const options: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () =>
            RESIDENT_PERMIT_IDS.map((id) => ({
                id,
                label: translate(`field.resident-permit.option.${id.toLowerCase().replace(/_/g, '-')}`),
            })),
        [translate],
    );

    return <Select name={name} label={label} options={options} />;
};

export default ResidentPermitField;
